import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["name", "errorText", "showValidationErrorOnChange", "onChange", "value"];
import React from 'react';
import { useExtendedField } from '../../../../hooks';
import Checkbox from '../Checkbox';

var CheckboxInput = function CheckboxInput(_ref) {
  var name = _ref.name,
      errorText = _ref.errorText,
      showValidationErrorOnChange = _ref.showValidationErrorOnChange,
      onChange = _ref.onChange,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useExtendedField = useExtendedField({
    name: name,
    type: 'checkbox',
    value: value
  }, {
    onChange: onChange,
    errorText: errorText,
    showValidationErrorOnChange: showValidationErrorOnChange
  }),
      _useExtendedField2 = _slicedToArray(_useExtendedField, 2),
      formikFieldConfig = _useExtendedField2[0],
      error = _useExtendedField2[1].errorText;

  return /*#__PURE__*/React.createElement(Checkbox, _extends({
    errorText: error
  }, formikFieldConfig, rest));
};

export default CheckboxInput;